import { useMutation, useQuery, useQueryClient } from "react-query";
import { showErrorToast } from "~/components/Toast";
import i18n from "~/i18n";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useDataFilterPresets = (config) => {
  return useQuery({
    ...config,
    queryKey: ["data-filter-presets"],
    queryFn: () =>
      fetch({
        url: `${Angie.api_url}/data-filters`,
      }),
  });
};

export const useSaveDataFilterPreset = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/data-filters`,
        method: "POST",
        body: data,
      }),
    onError: () => {
      showErrorToast(i18n.t("Unable to save preset."));
    },
  });
};

export const useUpdateDataFilterPreset = () => {
  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/data-filters/${data.id}`,
        method: "PUT",
        body: data,
      }),
    onError: () => {
      showErrorToast(i18n.t("Unable to update preset."));
    },
  });
};

export const useDeleteDataFilterPreset = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () =>
      fetch({
        url: `${Angie.api_url}/data-filters/${id}`,
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["data-filter-presets"]);
    },
    onError: () => {
      showErrorToast(i18n.t("Unable to delete preset."));
    },
  });
};
